import React, { Component } from 'react';
import cx from 'classnames';
import { omit } from 'lodash';
import Table from '../Table';
import Button from '../../Button';
import { comparePrePropsAndNextProps } from '../../../lib/common';
import './TableWithSummary.scss';

class TableWithSummary extends Component {
  /**
   *  Component 의 변경되는 props 와 state 가 있을 경우에만,
   *  render 메소드를 호출할 수 있도록 함
   */
  shouldComponentUpdate = (nextProps) => {
    return comparePrePropsAndNextProps([[omit(nextProps, ['onCheck']), omit(this.props, ['onCheck'])]]);
  };

  render() {
    const {
      className,
      totalCnt,
      head,
      initialOption,
      checkedIdList,
      deleteCheckedIdList,
      getExcelDownload,
      getList,
      isUsedCheckbox,
      ...res
    } = this.props;

    return (
      <div className={cx('table-with-summary', className)}>
        <div className="summary">
          <span className="total-cnt">
            <span className="cnt">{totalCnt}</span>건이 조회되었습니다.
          </span>

          <div className="button-group">
            {/* isUsedCheckbox 값이 false이거나 deleteCheckedIdList 함수를 정의 해주지 않으면 해당 버튼이 노출될 필요가 없습니다. */}
            {isUsedCheckbox && deleteCheckedIdList ? (
              <Button
                isRadius
                color="primary"
                text="삭제"
                disabled={!checkedIdList.length}
                onClick={() => deleteCheckedIdList()}
              />
            ) : null}

            {/* getExcelSheet 함수를 정의 해주지 않으면 해당 버튼이 노출될 필요가 없습니다. */}
            {getExcelDownload ? (
              <Button isRadius color="primary" text="엑셀다운" onClick={() => getExcelDownload()} />
            ) : null}

            {initialOption && initialOption.filterOption && getList ? (
              <Button isRadius color="primary" text="필터 초기화" onClick={() => getList(initialOption)} />
            ) : null}
          </div>
        </div>
        {head ? <div className="table-head">{head}</div> : null}

        <Table
          {...res}
          initialOption={initialOption}
          getList={getList}
          isUsedCheckbox={isUsedCheckbox}
          checkedIdList={checkedIdList}
        />
      </div>
    );
  }
}

export default TableWithSummary;
